import { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/school-profile/SchoolProfileAction";
import { redirectToPages, resultAlert } from "../../../../../_helpers/Helpers";
import { useSubheader } from "../../../../../_metronic/layout";
import "../../../../../_metronic/_assets/sass/pages/wizard/wizard-4.scss";
import KTWizard from "../../../../../_metronic/_assets/js/components/wizard";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { SchoolProfileEditForm } from "./SchoolProfileEditForm";

export function SchoolProfileEdit() {
  // Subheader
  const suhbeader = useSubheader();
  const [title, setTitle] = useState("");  
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, schoolProfile } = useSelector(
    (state) => ({
      actionsLoading: state.schoolProfile.actionsLoading,
      isSuccess: state.schoolProfile.isSuccess,
      type: state.schoolProfile.type,
      schoolProfile: state.schoolProfile.schoolProfile
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getSchoolProfile());
    return () => dispatch(actions.cleanSchoolProfileState());
  }, [dispatch]);
  
  useEffect(() => {
    let _title = "Okul Profil Bilgisi";
    setTitle(_title);
    suhbeader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Okul Profil Bilgilerini Kaydeder
  const saveSchoolProfile = (formData) => {
    dispatch(actions.saveSchoolProfile(formData)).then(({ type, message }) => resultAlert(type, message));
  };

  const btnRef = useRef();  
  const saveSchoolProfileClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  // School Profile Form Wizard
  const options = {
    startStep: 1,
    clickableSteps: true
  };

  new KTWizard(document.querySelector("#school_profile_form_wizard"), options);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <SchoolProfileEditForm
          schoolProfile={schoolProfile}
          btnRef={btnRef}
          saveSchoolProfile={saveSchoolProfile}
        />         
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveSchoolProfileClick}
          >
            Kaydet
          </button>
        </div>
      </CardFooter>
    </Card>
  );
}